import * as i0 from '@angular/core';
import { Component, Input, NgModule, InjectionToken, EventEmitter, Inject, Injector, Injectable } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/cdk/portal';
import { ComponentPortal, PortalModule } from '@angular/cdk/portal';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import * as i1$1 from '@angular/cdk/overlay';
import { OverlayModule, OverlayConfig } from '@angular/cdk/overlay';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import * as i2 from '@angular/router';
import { NavigationStart } from '@angular/router';

class ProgressBarComponent {
    constructor() {
        this.progress = 0;
        this.total = 100;
        this.showNum = false;
        this.trackChanges = false;
    }
    ngOnChanges(changes) {
        if (this.trackChanges && !changes["progress"].isFirstChange()) {
            this.progress = Math.floor((this.progress / this.total) * 100);
        }
    }
    ngOnInit() {
        //if we don't have a total aka no requirement, it's 100%.
        if (this.total === 0) {
            this.total = this.progress;
        }
        //if the progress is greater than the total, it's also 100%.
        if (this.progress > this.total) {
            this.progress = 100;
            this.total = 100;
        }
        this.progress = Math.floor((this.progress / this.total) * 100);
        /* < 70 was bad, < 85 was ok*/
        if (!this.scoreType) {
            if (this.progress < 50) {
                this.scoreType = 'bad';
            }
            else if (this.progress < 75) {
                this.scoreType = 'ok';
            }
            else {
                this.scoreType = 'good';
            }
        }
    }
}
ProgressBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ProgressBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ProgressBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: ProgressBarComponent, selector: "ui-progress-bar", inputs: { progress: "progress", total: "total", showNum: "showNum", trackChanges: "trackChanges", scoreType: "scoreType" }, usesOnChanges: true, ngImport: i0, template: `
    <div class="progress-bar">
      <div class="progress-bar__internal progress-bar__internal--{{scoreType}}" [ngStyle]="{'width': progress + '%'}" [ngClass]="{'progress-bar__min-width': showNum}">
        <span *ngIf="showNum" class="progress-bar__score">{{progress}}%</span>
      </div>
    </div>
  `, isInline: true, styles: [".progress-bar{border-radius:13px;background-color:#f0f0f5;width:100%;padding:.2rem .25rem;margin-top:1%;position:relative}.progress-bar__internal{border-radius:8px;height:.9rem;width:0;line-height:1.25;transition:width .3s ease-in-out}.progress-bar__min-width{min-width:1.7em}.progress-bar__internal--good{background-color:#34a853}.progress-bar__internal--ok{background-color:#ffd500}.progress-bar__internal--bad{background-color:#f20505}.progress-bar__score{float:right;color:#fff;font-weight:700;padding-right:5px;font-size:.8rem}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ui-progress-bar', template: `
    <div class="progress-bar">
      <div class="progress-bar__internal progress-bar__internal--{{scoreType}}" [ngStyle]="{'width': progress + '%'}" [ngClass]="{'progress-bar__min-width': showNum}">
        <span *ngIf="showNum" class="progress-bar__score">{{progress}}%</span>
      </div>
    </div>
  `, styles: [".progress-bar{border-radius:13px;background-color:#f0f0f5;width:100%;padding:.2rem .25rem;margin-top:1%;position:relative}.progress-bar__internal{border-radius:8px;height:.9rem;width:0;line-height:1.25;transition:width .3s ease-in-out}.progress-bar__min-width{min-width:1.7em}.progress-bar__internal--good{background-color:#34a853}.progress-bar__internal--ok{background-color:#ffd500}.progress-bar__internal--bad{background-color:#f20505}.progress-bar__score{float:right;color:#fff;font-weight:700;padding-right:5px;font-size:.8rem}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { progress: [{
                type: Input
            }], total: [{
                type: Input
            }], showNum: [{
                type: Input
            }], trackChanges: [{
                type: Input
            }], scoreType: [{
                type: Input
            }] } });

class ElementsModule {
}
ElementsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ElementsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ElementsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: ElementsModule, declarations: [ProgressBarComponent], imports: [CommonModule], exports: [ProgressBarComponent] });
ElementsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ElementsModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ElementsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ProgressBarComponent],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        ProgressBarComponent
                    ]
                }]
        }] });

const ACTIVE_LAYER_CONFIG = new InjectionToken('ACTIVE_LAYER_CONFIG');
const DEFAULT_LAYER_BACKDROP_CLASS = new InjectionToken('DEFAULT_LAYER_BACKDROP_CLASS');

class LayerOverlayRef {
    constructor(overlayRef) {
        this.overlayRef = overlayRef;
        this._beforeClose = new Subject();
        this._afterClosed = new Subject();
    }
    close(data) {
        this.componentInstance.animationStateChanged.pipe(filter(event => event.phaseName === 'start'), take(1)).subscribe(() => {
            this._beforeClose.next();
            this._beforeClose.complete();
            this.overlayRef.detachBackdrop();
        });
        this.componentInstance.animationStateChanged.pipe(filter(event => event.phaseName === 'done' && event.toState === 'leave'), take(1)).subscribe(() => {
            this.overlayRef.dispose();
            this._afterClosed.next(data);
            this._afterClosed.complete();
            this.componentInstance = null;
        });
        this.componentInstance.startExitAnimation();
    }
    afterClosed() {
        return this._afterClosed.asObservable();
    }
    beforeClose() {
        return this._beforeClose.asObservable();
    }
}

const ANIMATION_TIMINGS = '400ms cubic-bezier(0.25, 0.8, 0.25, 1)';
class LayerPanelComponent {
    constructor(layerRef, layerConfig) {
        this.layerRef = layerRef;
        this.layerConfig = layerConfig;
        this.animationState = 'enter';
        this.animationStateChanged = new EventEmitter();
    }
    ngOnInit() {
        this.selectedPortal = new ComponentPortal(this.layerConfig.component);
    }
    onAnimationStart(event) {
        this.animationStateChanged.emit(event);
    }
    onAnimationDone(event) {
        this.animationStateChanged.emit(event);
    }
    startExitAnimation() {
        this.animationState = 'leave';
    }
    close() {
        this.layerRef.close();
    }
}
LayerPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: LayerPanelComponent, deps: [{ token: LayerOverlayRef }, { token: ACTIVE_LAYER_CONFIG }], target: i0.ɵɵFactoryTarget.Component });
LayerPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: LayerPanelComponent, selector: "ui-layer-panel", ngImport: i0, template: "<div\nclass=\"panel\"\n[ngClass]=\"{'panel--right': layerConfig.position === 'left'}\"\n[@slideContent]=\"animationState\"\n(@slideContent.start)=\"onAnimationStart($event)\"\n(@slideContent.done)=\"onAnimationDone($event)\"\n>\n    <button tabindex=\"0\" class=\"panel__close\" (click)=\"close()\">\n        <mat-icon class=\"panel__icon\">{{layerConfig.position === 'left'?'logout':'login'}}</mat-icon>\n    </button>\n    <div class=\"content\">\n        <ng-template [cdkPortalOutlet]=\"selectedPortal\"></ng-template>\n    </div>\n</div>", styles: [".panel{position:relative;z-index:999;padding:0 30px;box-shadow:0 3px 6px #0000002e;border:1px solid #E0E0E0;border-radius:6px;box-sizing:border-box;background:#fff}.panel__close{position:absolute;display:flex;justify-content:center;padding:.85rem .5rem;-webkit-appearance:none;appearance:none;border-left:0;border-top:0;border-bottom:0;margin:0;border:0;left:0;background-color:#fff;cursor:pointer;border-radius:10px;box-sizing:border-box}.panel.panel--right .panel__close{left:unset;right:0}.panel__close:hover{background-color:#e6e6e6;transition:background-color .2s ease-in-out}.panel__icon{color:#727272}.content{padding-left:10px}.panel.panel--right .content{padding-left:0;padding-right:10px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i4.CdkPortalOutlet, selector: "[cdkPortalOutlet]", inputs: ["cdkPortalOutlet"], outputs: ["attached"], exportAs: ["cdkPortalOutlet"] }], animations: [
        trigger('fade', [
            state('fadeOut', style({ opacity: 0 })),
            state('fadeIn', style({ opacity: 1 })),
            transition('* => fadeIn', animate(ANIMATION_TIMINGS))
        ]),
        trigger('slideContent', [
            state('void', style({ transform: 'translate3d(0, 25%, 0) scale(0.9)', opacity: 0 })),
            state('enter', style({ transform: 'none', opacity: 1 })),
            state('leave', style({ transform: 'translate3d(0, 25%, 0)', opacity: 0 })),
            transition('* => *', animate(ANIMATION_TIMINGS)),
        ])
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: LayerPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ui-layer-panel', animations: [
                        trigger('fade', [
                            state('fadeOut', style({ opacity: 0 })),
                            state('fadeIn', style({ opacity: 1 })),
                            transition('* => fadeIn', animate(ANIMATION_TIMINGS))
                        ]),
                        trigger('slideContent', [
                            state('void', style({ transform: 'translate3d(0, 25%, 0) scale(0.9)', opacity: 0 })),
                            state('enter', style({ transform: 'none', opacity: 1 })),
                            state('leave', style({ transform: 'translate3d(0, 25%, 0)', opacity: 0 })),
                            transition('* => *', animate(ANIMATION_TIMINGS)),
                        ])
                    ], template: "<div\nclass=\"panel\"\n[ngClass]=\"{'panel--right': layerConfig.position === 'left'}\"\n[@slideContent]=\"animationState\"\n(@slideContent.start)=\"onAnimationStart($event)\"\n(@slideContent.done)=\"onAnimationDone($event)\"\n>\n    <button tabindex=\"0\" class=\"panel__close\" (click)=\"close()\">\n        <mat-icon class=\"panel__icon\">{{layerConfig.position === 'left'?'logout':'login'}}</mat-icon>\n    </button>\n    <div class=\"content\">\n        <ng-template [cdkPortalOutlet]=\"selectedPortal\"></ng-template>\n    </div>\n</div>", styles: [".panel{position:relative;z-index:999;padding:0 30px;box-shadow:0 3px 6px #0000002e;border:1px solid #E0E0E0;border-radius:6px;box-sizing:border-box;background:#fff}.panel__close{position:absolute;display:flex;justify-content:center;padding:.85rem .5rem;-webkit-appearance:none;appearance:none;border-left:0;border-top:0;border-bottom:0;margin:0;border:0;left:0;background-color:#fff;cursor:pointer;border-radius:10px;box-sizing:border-box}.panel.panel--right .panel__close{left:unset;right:0}.panel__close:hover{background-color:#e6e6e6;transition:background-color .2s ease-in-out}.panel__icon{color:#727272}.content{padding-left:10px}.panel.panel--right .content{padding-left:0;padding-right:10px}\n"] }]
        }], ctorParameters: function () { return [{ type: LayerOverlayRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [ACTIVE_LAYER_CONFIG]
                }] }]; } });

class LayersModule {
}
LayersModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: LayersModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LayersModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: LayersModule, declarations: [LayerPanelComponent], imports: [CommonModule,
        MatIconModule,
        MatButtonModule,
        OverlayModule,
        PortalModule] });
LayersModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: LayersModule, imports: [CommonModule,
        MatIconModule,
        MatButtonModule,
        OverlayModule,
        PortalModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: LayersModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        LayerPanelComponent
                    ],
                    imports: [
                        CommonModule,
                        MatIconModule,
                        MatButtonModule,
                        OverlayModule,
                        PortalModule
                    ],
                    exports: []
                }]
        }] });

class LayerService {
    constructor(overlay, router, backdropClass) {
        this.overlay = overlay;
        this.router = router;
        this.backdropClass = backdropClass;
        this._activeOverlay = null;
        this.sub = null;
    }
    close() {
        if (!this._activeOverlay) {
            return;
        }
        this._activeOverlay?.close();
        this._activeOverlay = null;
    }
    setupRouterSub() {
        if (this.sub) {
            return;
        }
        this.sub = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.close();
            }
        });
    }
    open(config) {
        if (!config.component) {
            throw new Error("no component provided to layer");
        }
        if (this._activeOverlay) {
            return;
        }
        this.setupRouterSub();
        this.close();
        const overlayRef = this.createOverlay(config);
        this._activeOverlay = new LayerOverlayRef(overlayRef);
        const overlayComponent = this.attachDialogContainer(overlayRef, config, this._activeOverlay);
        this._activeOverlay.componentInstance = overlayComponent;
        overlayRef.backdropClick().subscribe(_ => this._activeOverlay?.close());
        this._activeOverlay.afterClosed().subscribe(_ => { this._activeOverlay = null; });
        return this._activeOverlay;
    }
    createOverlay(config) {
        const overlayConfig = this.getOverlayConfig(config);
        return this.overlay.create(overlayConfig);
    }
    attachDialogContainer(overlayRef, config, layerRef) {
        const injector = this.createInjector(config, layerRef);
        const containerPortal = new ComponentPortal(LayerPanelComponent, null, injector);
        const containerRef = overlayRef.attach(containerPortal);
        return containerRef.instance;
    }
    createInjector(config, layerRef) {
        return Injector.create({ providers: [
                {
                    provide: LayerOverlayRef,
                    useValue: layerRef
                },
                {
                    provide: ACTIVE_LAYER_CONFIG,
                    useValue: config
                }
            ] });
    }
    getOverlayConfig(config) {
        let positionStrategy = this.overlay.position()
            .global()
            .centerHorizontally()
            .centerVertically();
        positionStrategy = config.position === 'left' ? positionStrategy.left() : positionStrategy.right();
        const overlayConfig = new OverlayConfig({
            scrollStrategy: this.overlay.scrollStrategies.noop(),
            positionStrategy,
            hasBackdrop: true,
            backdropClass: config.backdropClass || this.backdropClass,
            disposeOnNavigation: true
        });
        return overlayConfig;
    }
}
LayerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: LayerService, deps: [{ token: i1$1.Overlay }, { token: i2.Router }, { token: DEFAULT_LAYER_BACKDROP_CLASS }], target: i0.ɵɵFactoryTarget.Injectable });
LayerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: LayerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: LayerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Overlay }, { type: i2.Router }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DEFAULT_LAYER_BACKDROP_CLASS]
                }] }]; } });

/*
 * Public API Surface of pocket-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ACTIVE_LAYER_CONFIG, DEFAULT_LAYER_BACKDROP_CLASS, ElementsModule, LayerOverlayRef, LayerPanelComponent, LayerService, LayersModule, ProgressBarComponent };
